import { render, staticRenderFns } from "./ContentProjection.vue?vue&type=template&id=4a64530e"
import script from "./ContentProjection.vue?vue&type=script&lang=ts"
export * from "./ContentProjection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports